(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.headerMediaQuery = window.matchMedia('(max-width: 1100px)');
      this.onHeaderResize = this.setHeaderHeight.bind(this);
      this.headerMediaQuery.addEventListener('change', this.onHeaderResize);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      } else {
        this.header.classList.add('qs-header-soft-scroll');
      }

      this.currentScrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      this.upScrollDistance = 0;
      this.downScrollDistance = 0;
      this.lastScrollTime = 0;
      this.scrollRevealDistance = 72;
      this.scrollHideDistance = 32;
      this.scrollIntentGap = 300;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerMediaQuery?.removeEventListener('change', this.onHeaderResize);
      this.headerObserver?.disconnect();
      if (this.scrollFrame != null) cancelAnimationFrame(this.scrollFrame);
    }

    createObserver() {
      this.headerObserver = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        this.headerObserver.disconnect();
      });
      this.headerObserver.observe(this.header);
    }

    queueScrollAction(action) {
      if (this.scrollFrame != null) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        if (document.body.classList.contains('qs-menu-open') || this.predictiveSearch?.isOpen) return;
        this[action]();
      });
    }

    onScroll() {
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      const now = performance.now();

      if (document.body.classList.contains('qs-menu-open') || this.predictiveSearch?.isOpen) {
        this.currentScrollTop = scrollTop;
        this.upScrollDistance = 0;
        this.downScrollDistance = 0;
        this.lastScrollTime = now;
        if (this.scrollFrame != null) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        return;
      }

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.upScrollDistance = 0;
        this.downScrollDistance = 0;
        this.currentScrollTop = scrollTop;
        this.lastScrollTime = now;
        this.queueScrollAction('reset');
        return;
      }

      if (scrollTop <= this.headerBounds.bottom) {
        this.currentScrollTop = scrollTop;
        this.upScrollDistance = 0;
        this.downScrollDistance = 0;
        this.lastScrollTime = now;
        return;
      }

      this.header.classList.add('scrolled-past-header');
      const delta = scrollTop - this.currentScrollTop;
      if (now - this.lastScrollTime > this.scrollIntentGap) {
        this.upScrollDistance = 0;
        this.downScrollDistance = 0;
      }
      if (Math.abs(delta) < 2) return;
      this.currentScrollTop = scrollTop;
      this.lastScrollTime = now;

      if (delta > 0) {
        this.upScrollDistance = 0;
        this.downScrollDistance += delta;
        if (!this.preventHide && this.downScrollDistance >= this.scrollHideDistance) {
          this.queueScrollAction('hide');
        }
      } else {
        this.downScrollDistance = 0;
        this.upScrollDistance -= delta;
        if (!this.preventReveal && this.upScrollDistance >= this.scrollRevealDistance) {
          this.queueScrollAction('reveal');
        }
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.preventHide) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.preventReveal) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quidsin-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFaq = (root) => {
      if (!root || root.dataset.faqInitialized === 'true') return;
      root.dataset.faqInitialized = 'true';

      const search = root.querySelector('[data-faq-search]');
      const filters = Array.from(root.querySelectorAll('[data-faq-filter]'));
      const groups = Array.from(root.querySelectorAll('[data-faq-group]'));
      const noResults = root.querySelector('[data-faq-no-results]');
      let activeCategory = 'all';

      const applyFilters = () => {
        const query = search ? search.value.trim().toLowerCase() : '';
        let visibleTotal = 0;

        groups.forEach((group) => {
          let visibleInGroup = 0;
          const items = Array.from(group.querySelectorAll('[data-faq-item]'));

          items.forEach((item) => {
            const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
            const searchText = (item.dataset.search || item.textContent || '').toLowerCase();
            const searchMatch = query === '' || searchText.includes(query);
            const visible = categoryMatch && searchMatch;

            item.hidden = !visible;
            if (visible) visibleInGroup += 1;
          });

          group.hidden = visibleInGroup === 0;
          visibleTotal += visibleInGroup;
        });

        if (noResults) noResults.hidden = visibleTotal !== 0;
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          activeCategory = button.dataset.faqFilter || 'all';

          filters.forEach((filter) => {
            const active = filter === button;
            filter.classList.toggle('is-active', active);
            filter.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          applyFilters();
        });
      });

      if (search) {
        search.addEventListener('input', applyFilters);
      }

      root.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

        root.querySelectorAll('details[open]').forEach((details) => {
          if (details !== opened) details.open = false;
        });
      }, true);

      applyFilters();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-faq-section]').forEach(initFaq);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
